import { isNil, forEach, debounce } from 'lodash';

import { getElementNotFoundError } from '../../01-helpers/utilities/error';
import containerManager from '../../01-helpers/filter-context/container-manager';
import { getSessionStorage } from '../../01-helpers/session-manager';

import { SEARCH_CLICKED } from '../../02-const/event-names';
import { publish } from '../../01-helpers/event-manager/index';

/* ========================================================================== */

const
	storageKey = 'filters';

/**
 * Search module - This module with send a query to an endpoint using the provided parameters
 */
class Search {
	constructor(baseElement) {
		this.filterContext = containerManager.getContainer();

		if (isNil(baseElement)) {
			console.error(getElementNotFoundError(baseElement, Search));

			return;
		}

		this.baseElement = baseElement;
		this._onInit();
		this.bindEvents();
	}

	_onInit() {
		const filters = getSessionStorage(storageKey);

		if (isNil(filters)) {
			return;
		}

		if (filters.search || filters.cityId || filters.courseId) {
			// send submit
			this._submit();
		}

	}

	_submit() {
		publish(SEARCH_CLICKED);

		// We don't actually want to update any values,
		// just trigger a refresh from the endpoint.
		this.filterContext.update({}, { refresh: true });
	}

	bindEvents() {
		const submitButtons = this.baseElement.querySelectorAll(
				'[data-search-submit]'
			),
			form = this.baseElement;

		// Prevent default behavior & propagation
		form.addEventListener('submit', (event) => event.preventDefault());

		form.addEventListener('keyup', debounce((event) => {
			if (event.keyCode == 13) {
				this._submit();
			}
		}, 300, { 'leading': false, 'trailing': true }));

		forEach(submitButtons, (submitButton) => {
			submitButton.addEventListener(
				'click',
				debounce(() => {
					this._submit();
				}, 250)
			);
		});
	}
}

export { Search };
